<template>
  <div class="slider">
    <button
      v-if="businesses.length"
      class="prev"
      @click="onPrev"
    >
      <svg>
        <use xlink:href="#icon-arrow2"></use>
      </svg>
    </button>
    <ul
      v-if="businesses.length"
      ref="list"
    >
      <li
        v-for="business in businesses"
        :key="business.id"
        ref="tiles"
      >
        <slot />
        <nearby-business :business="business" />
      </li>
    </ul>
    <div
      v-else
      class="loading-wrapper"
    >
      <small-loading-animation />
    </div>
    <button
      v-if="businesses.length"
      class="next"
      @click="onNext"
    >
      <svg>
        <use xlink:href="#icon-arrow2"></use>
      </svg>
    </button>
  </div>
</template>
<script>
import PerfectScrollbar from 'perfect-scrollbar'

import NearbyBusiness from './NearbyBusiness'
import SmallLoadingAnimation from '../../../shared/SmallLoadingAnimation'

const nullScrollbar = () => ({
  destroy: () => {},
})

export default {
  name: 'NearbyBusinessSlider',
  props: {
    businesses: {
      type: Array,
      required: true,
    },
  },
  components: {
    NearbyBusiness,
    SmallLoadingAnimation,
  },
  watch: {
    businesses: {
      immediate: true,
      handler(val) {
        if (this.ps || !val.length) {
          this.ps.destroy()
          this.ps = nullScrollbar()
          return
        }
        this.$nextTick(() => {
          this.ps = new PerfectScrollbar(this.$refs.list)
        })
      },
    },
  },
  data() {
    return {
      ps: nullScrollbar(),
    }
  },
  methods: {
    onPrev() {
      const tileWidth = this.$refs.tiles[0].getBoundingClientRect().width

      this.$refs.list.scrollTo({
        left: this.$refs.list.scrollLeft - tileWidth,
        behavior: 'smooth',
      })
    },
    onNext() {
      const tileWidth = this.$refs.tiles[0].getBoundingClientRect().width

      this.$refs.list.scrollTo({
        left: this.$refs.list.scrollLeft + tileWidth,
        behavior: 'smooth',
      })
    },
  },
}
</script>
<style lang="scss" scoped>

.slider {
  display: flex;
  width: 100%;
}

button {
  background: $c-alabaster;
  border: none;
  cursor: pointer;
}

ul {
  align-items: stretch;
  display: flex;
  height: 300px;
  margin: auto;
  max-width: calc(100% - 88px);
  overflow: hidden;
  padding: 0 0 20px;
  position: relative;
  width: 100%;
}

svg {
  height: 28px;
  width: 28px;

  .prev & {
    transform: rotate(180deg);
  }
}

li {
  align-items: stretch;
  display: flex;

  & + & {
    margin: 0 0 0 10px;
  }
}

.loading-wrapper {
  margin: 40px auto;
  max-width: 100px;
}
</style>
